import { ExecutiveCommandSectionModel } from "./ExecutiveCommandSection.model";

export class ExecutiveCommandSection extends ExecutiveCommandSectionModel {
    // Add custom methods here
}
